import { useQuery } from '@hooks/reactQuery';

import { getDashboardAssetSummaryPerOrganization } from '@api/dashboardPO';

import { extractQueryParams } from '@utils/common';

import { TDashboardSummaryPerOrganizationDTO } from '@interfaces/platform/dto/platformDashboardDTO';

import { refetchOptions } from '@constants/common';
import { DASHBOARD_ASSET_SUMMARY_PER_ORGANIZATION } from '@constants/queryKeys';

const useQueryDashboardAssetSummaryPerOrganization = (params: TDashboardSummaryPerOrganizationDTO) => {
	const {
		page,
		pageSize,
		sortDirection,
		sortFieldName,
		searchValue,
	} = params;

	const {
		data: dashboardAssetSummaryPerOrganization,
		isLoading: isLoadingDashboardAssetSummaryPerOrganization,
		isFetching: isFetchingDashboardAssetSummaryPerOrganization,
	} = useQuery({
		queryKey: [
			DASHBOARD_ASSET_SUMMARY_PER_ORGANIZATION,
			{
				page,
				pageSize,
				sortDirection,
				sortFieldName,
				searchValue,
			},
		],
		queryFn: extractQueryParams(getDashboardAssetSummaryPerOrganization),
		enabled: [!!params],
		...refetchOptions,
	});

	return {
		dashboardAssetSummaryPerOrganization: dashboardAssetSummaryPerOrganization?.items || [],
		countOfRecords: dashboardAssetSummaryPerOrganization?.count || 0,
		isLoadingDashboardAssetSummaryPerOrganization: isLoadingDashboardAssetSummaryPerOrganization
			|| isFetchingDashboardAssetSummaryPerOrganization,
	};
};

export default useQueryDashboardAssetSummaryPerOrganization;

